import React from 'react'
import { InvoiceFormContext } from './invoice-form-context'
import { InvoiceFormView } from './invoice-form-view'

export const InvoiceFormContainer: React.SFC = () => (
  <InvoiceFormContext.Provider>
    <InvoiceFormView />
  </InvoiceFormContext.Provider>
)
